export const homeLocaleMessages = {"2":{"en":"Register"},"3":{"en":"Login"}}